import { createAsyncThunk } from "@reduxjs/toolkit"
import { navigate } from "gatsby"
import { logTransaction } from "../appActions"
import { axiosGet, axiosPost, axiosPut } from "../../utilities/axiosRequest"
import queryString from "query-string"
import {
    userLoginURL,
    authTokenURL,
    userProfileURL,
    forgotPasswordURL,
    setNewPasswordURL,
    lookupsURL,
    fetchTimeZoneURL,
    consultantsURL,
    fetchStatesURL,
    fetchCountriesURL,
    getBlockoutDaysURL,
    inserOrUpdateBlockoutURL,
    getClinicsUserURL,
    timeTrackerURL,
    updateUserURL,
    updateLoginUserProfileURL,
    getAgoraToken,
    sendOtpToLoginPhoneURL,
    userTimeTrackingBasedOnCategoryURL,
    updateUserTimeTrackingBasedOnCategoryURL,
} from "../../apiEndPoints"
import axios from "axios"
import {
    loginFailure,
    loginRequest,
    loginSuccess,
    updateAuth,
    updateBlockoutDays,
    updateLanguages,
    updateResources,
    updateSchedule,
    updateTimeZones,
    updateTokenRefreshed,
    updateUserProfile,
    associatedClinicsUsers,
    updateLoginTracker,
    updateSubscriptionDetails,
    logoutAction,
    updateAlert,
    updateActivtyTracker,
} from "./loginSlice"
import moment from "moment"
import { checkAccess, resourceList } from "../../utilities/checkResourceAccess"
import { findWhereToNavigate } from "../../utilities/findWhereToNavigate"
import { authInstance } from "../../utilities/axios"
import {
    setShowSelectProgramModal,
    updateProgram,
    updateProgramListForUser,
} from "../user/userSlice"
var addUserToFb = () => {}
if (typeof window !== `undefined`) {
    addUserToFb = require("../../utilities/addUserToFb")
}

export function userLogin({ loginData }) {
    return async function (dispatch) {
        try {
            dispatch(loginRequest())
            const response = await axiosPost(userLoginURL, loginData)
            if (response.data.statusCD === 200) {
                const user = response.data.responseData
                navigate("/")
                console.log("login data from response", user)
                dispatch(logTransaction("Login Success", loginData))
                dispatch(loginSuccess(user))
                dispatch(updateUserProfile(user.profileForUser[0]))
            } else {
                dispatch(logTransaction("Login Success", response))
                alert("Couldn't log you in! \n \n" + response.data.statusMSG)
                dispatch(loginFailure(response.data.statusMSG))
            }
        } catch (error) {
            console.log("This is the component i need")
            alert("Login failed", error.message)
            dispatch(logTransaction("Login Success failure", error))
            dispatch(loginFailure(error.message))
        }
    }
}

export function generateToken({
    data,
    userType = "dashboard_user",
    success,
    params,
}) {
    return async function (dispatch) {
        try {
            console.log("sdkfjsdlfjl")
            let url = authTokenURL
            // if (params?.mobileNo && params?.otp) {
            //     url += `?grant_type=password&username=${params?.mobileNo}&password=${params?.otp}`
            // }
            dispatch(loginRequest())
            var config = {
                method: "post",
                url,
                headers: {
                    UserType: userType,
                    Authorization:
                        "Basic ZGFzaGJvYXJkLWFwcDpkYXNoYm9hcmRfc2VjcmV0X2tleQ==",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                data: queryString.stringify(data),
            }
            console.log("data", data)
            console.log(
                "url",
                authTokenURL,
                "headers ",
                userType,
                "Data",
                queryString.stringify(data)
            )
            console.log("COnfig", config)
            const response = await axios(config)
            console.log("token generation response", response)
            if (response.status === 200) {
                console.log("This is the success token", response)
                dispatch(updateAuth(response.data))
                success()
                dispatch(logTransaction("Auth Success", response))
            } else {
                console.log("This is the component i need")
                alert("Login failed", response.data.message)
                dispatch(loginFailure(response))
                dispatch(logTransaction("Auth Failed", response))
            }
        } catch (err) {
            console.log("This is the component i need")
            console.log("login error", err)
            alert("Login failed", err.message)
            dispatch(logTransaction("Auth failure", err))
            dispatch(loginFailure(err.message))
        }
    }
}

export function getUserProfile(enableNavigation = true) {
    return async function (dispatch, getState) {
        try {
            let url = userProfileURL + `?loginType=DOCTORITE`
            const response = await axiosGet(url)
            if (response.data.statusCD === 200) {
                const user = response.data.responseData
                const userData = user.profileForUser[0]
                let resources = []
                user?.userResources.map(r => {
                    ;(r !== null || r.name !== undefined) &&
                        resources.push(r.name)
                })
                if (typeof window !== undefined) {
                    if (
                        window.location.hostname === "clinics.doctorite.ai" &&
                        user?.userResources.length &&
                        user?.userResources?.[0]?.role_id ===
                            "CareNavigator_Global_CUSTOM_26_71_90"
                    ) {
                        alert("Please login using dashboard.doctorite.ai")
                        localStorage.removeItem("userAuth")
                        window?.navigation?.navigate(
                            "https://dashboard.doctorite.ai/"
                        )
                        return
                    }
                }

                dispatch(logTransaction("Login Success", response))
                dispatch(updateUserProfile(user.profileForUser[0]))

                dispatch(loginSuccess(user))
                localStorage.setItem("resources", JSON.stringify(resources))
                dispatch(updateResources(resources))
                // add user in firestore chat app
                if (typeof window !== `undefined`)
                    addUserToFb.addUserToFb(userData)

                if (enableNavigation) {
                    const programListForUser = user?.programListForUser?.filter(
                        item => item.programId != 2
                    ) || [
                        {
                            programId: 1,
                            programName: "BHI",
                            programDuration: 0,
                        },
                    ]

                    dispatch(
                        updateProgramListForUser(
                            programListForUser.map(item => {
                                return {
                                    id: item.programId,
                                    programName: item.programName,
                                    programDuration: item.programDuration,
                                }
                            })
                        )
                    )
                    if (programListForUser?.length > 1) {
                        dispatch(
                            setShowSelectProgramModal(programId => {
                                if (user.profileForUser[0].onBoarded) {
                                    findWhereToNavigate(resources)
                                    // navigate("/")
                                } else {
                                    navigate("/onboarding")
                                }
                                dispatch(loginTimeTracker(user, programId))
                            })
                        )
                    } else {
                        const program = programListForUser[0]
                        dispatch(loginTimeTracker(user, program.programId))
                        // dispatch(
                        //     updateProgram({
                        //         id: program.programId,
                        //         programName: program.programName,
                        //         programDuration: program.programDuration,
                        //     })
                        // )
                        dispatch(
                            updateProgram({
                                id: 1,
                                programName: "BHI",
                                programDuration: 13,
                            })
                        )
                        localStorage.setItem(
                            "selectedProgram",
                            JSON.stringify({
                                id: 1,
                                programName: "BHI",
                                programDuration: 13,
                            })
                        )
                        dispatch(loginTimeTracker(user, program.programId))
                        const {
                            organizationListForUser,
                            clinicListForUser,
                            profileForUser,
                        } = user
                        const org = organizationListForUser?.[0]
                        const userProfile = profileForUser?.[0]
                        console.log(userProfile, "sdlkdsjflkdsjfldsjfldsjfl")

                        dispatch(
                            updateSubscriptionDetails({
                                isFreeTrial: false,
                                subscription: org?.stripe_sub_id || null,
                            })
                        )
                        if (user.profileForUser[0].onBoarded) {
                            const hasActiveSubscription =
                                (org?.stripe_sub_id &&
                                    org?.status === "active") ||
                                org?.allow_free_trial
                            if (hasActiveSubscription) {
                                findWhereToNavigate(resources)
                            } else {
                                // Only an admin can act on a lapsed
                                // subscription (view billing, resubscribe),
                                // so send them to the subscribe page —
                                // everyone else gets logged out instead of
                                // left stuck on a page they can't use.
                                const roleId =
                                    user?.userResources?.[0]?.role_id || ""
                                const isAdmin = roleId
                                    .toLowerCase()
                                    .includes("admin")
                                if (isAdmin) {
                                    navigate("/subscriptions/subscribe")
                                } else {
                                    dispatch(
                                        updateAlert({
                                            open: true,
                                            vertical: "top",
                                            horizontal: "center",
                                            duration: 6000,
                                            type: "error",
                                            variant: "filled",
                                            msg: "Your organization's subscription is inactive. Please contact your admin.",
                                        })
                                    )
                                    dispatch(logoutAction())
                                    navigate("/login")
                                }
                            }
                        } else {
                            navigate("/onboarding")
                        }
                    }
                }
            } else {
                dispatch(logTransaction("Login Success", response))
                dispatch(loginFailure(response.data.statusMSG))
                alert("Couldn't log you in! \n \n" + response.data.statusMSG)
            }
        } catch (error) {
            console.log("This is the component i need", error)
            // alert("Login failed", error.message)
            dispatch(logTransaction("Login Success failure", error))
            dispatch(loginFailure(error.message))
        }
    }
}

export function forgotPassword({ email }, success, failure) {
    return async function (dispatch) {
        try {
            // let url = forgotPasswordURL + `?email=${email}&userType=${userType}`
            let url = forgotPasswordURL + `?email=${email}`
            const response = await axiosPost(url, {})
            console.log("response", response)
            console.log(success, "kldjfsldkjf")
            if (response.data.statusCD === 200) {
                dispatch(logTransaction("Forgot Password Success", response))
                // alert(response.data.responseData);
                success &&
                    success(
                        response?.data?.statusMSG ||
                            "If the account is registered with this address, an email will be sent to it."
                    )
                // alert(
                //   "If the account is registered with this address, an email will be sent to it."
                // )
            } else {
                // alert(response.data.statusMSG)
                failure && failure(response.data.statusMSG)
                dispatch(logTransaction("Forgot Password failure", response))
            }
        } catch (error) {
            // alert("An error occured", error)
            console.log(error, "sdfjkdsjfl")
            failure("An error occured")
            console.log("forgot password error", error)
            dispatch(logTransaction("Forgot Password failure", error))
        }
    }
}

export function setNewPassword(data, success, failure) {
    return async function (dispatch) {
        try {
            let url =
                setNewPasswordURL +
                `?userName=${data.userName}&newPassword=${data.newPassword}&token=${data.token}`
            const response = await axiosPut(url, {})
            console.log("response", response)
            if (response.data.statusCD === 200) {
                success("Password changed successfully")
                // // window && window.close()
                dispatch(logTransaction("Set New Password Success", response))
            } else {
                // alert(response.data.statusMSG)
                failure(response.data.statusMSG)
                dispatch(logTransaction("Set New Password failure", response))
            }
        } catch (error) {
            // alert("An error occured", error)
            failure("An error occured")
            console.log("Set New password error", error)
            dispatch(logTransaction("Set New Password failure", error))
        }
    }
}

export function refreshToken({ data }) {
    return async function (dispatch) {
        try {
            var config = {
                method: "post",
                url: authTokenURL,
                headers: {
                    UserType: "dashboard_user",
                    Authorization:
                        "Basic ZGFzaGJvYXJkLWFwcDpkYXNoYm9hcmRfc2VjcmV0X2tleQ==",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                data: queryString.stringify(data),
            }
            console.log("data", data)
            console.log(
                "url",
                authTokenURL,
                "Data",
                queryString.stringify(data)
            )
            console.log("Config", config)
            const response = await axios(config)
            if (response.status === 200) {
                dispatch(updateAuth(response.data))
                dispatch(updateTokenRefreshed(true))
                dispatch(logTransaction("Refresh Auth Success", response))
                // window !== undefined && window.location.reload(true);
            } else {
                dispatch(logTransaction("Refresh Auth Failed", response))
            }
        } catch (err) {
            console.log("login error", err)
            dispatch(logTransaction("Refresh Auth failure", err))
        }
    }
}

export function fetchLanguages() {
    return async function (dispatch, getState) {
        try {
            let user = getState().login.user
            let orgId = user?.organizationlistforuser?.[0]?.organizationId
            let url = lookupsURL + `?lookupCategoryId=${10035}&appLanguageId=1`
            if (orgId !== null && orgId !== undefined) {
                url = url + `&organizationId=${orgId}`
            }
            const response = await axiosGet(url)
            if (
                response.data.statusCD === 200 &&
                response.data.responseData.length > 0
            ) {
                let array = response.data.responseData.filter(l => l.status)
                dispatch(logTransaction("Fetch Languages", response))
                dispatch(updateLanguages(array))
            } else {
                dispatch(updateLanguages([]))
                dispatch(logTransaction("Fetch Languages Error", response))
            }
        } catch (err) {
            console.log("login error", err)
            dispatch(updateLanguages([]))
            dispatch(logTransaction("Refresh Auth failure", err))
        }
    }
}

export function fetchTimeZone() {
    return async function (dispatch) {
        try {
            let url = fetchTimeZoneURL
            const response = await axiosGet(url)
            if (
                response.data.statusCD === 200 &&
                response.data.responseData.length > 0
            ) {
                dispatch(updateTimeZones(response.data.responseData))
                dispatch(logTransaction("Fetch time zones success", response))
            } else {
                dispatch(updateTimeZones([]))
                dispatch(logTransaction("Fetch time zones failure", response))
            }
        } catch (err) {
            dispatch(updateLanguages([]))
            dispatch(logTransaction("Fetch time zones failure", err))
        }
    }
}

export function fetchSchedule() {
    return function (dispatch, getState) {
        let url = `user/${getState().login.userProfile.userId}/schedule`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(
                        logTransaction("Fetch Schedule Consultant", response)
                    )
                    dispatch(updateSchedule(response.data.responseData[0]))
                } else {
                    dispatch(
                        logTransaction(
                            "Fetch Schedule Consultant error",
                            response
                        )
                    )
                    dispatch(updateSchedule({}))
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction("Fetch Schedule Consultant failure", err)
                )
                dispatch(updateSchedule({}))
            })
    }
}

export function insertOrUpdateConsultantSchedule(inputData, success, failure) {
    return function (dispatch, getState) {
        console.log("Insert schedule ", inputData.id)
        let id = getState().login.userProfile.userId
        let url = `user/${id}/schedule`

        let data = {
            ...inputData,
            id: id,
        }
        console.log("schedule", JSON.stringify(data))
        axiosPost(url, data)
            .then(response => {
                if (response.data.statusCD === 200) {
                    console.log("insertOrUpdateConsultantSchedule  success")
                    dispatch(
                        logTransaction(
                            "Insert Or Update consultant Schedule",
                            inputData
                        )
                    )
                    success && success()
                } else {
                    failure && failure()
                    dispatch(
                        logTransaction(
                            "Insert Or Update consultant Schedule Failed",
                            inputData
                        )
                    )
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction(
                        "Insert Or Update consultant Schedule Failed",
                        err
                    )
                )
            })
    }
}

// export function updateConsultant(user, success, failure) {
//   return function (dispatch, getState) {
//     console.log(user, "lkfjlsdkfjsdjflskdf")
//     let url = consultantsURL + `/${user.id}`
//     axiosPut(url, JSON.stringify(user))
//       .then(response => {
//         if (response.data.statusCD === 200) {
//           localStorage.setItem("userProfile", JSON.stringify(user))
//           dispatch(logTransaction("Consultant Updated", response))
//           success && success()
//         } else {
//           failure && failure()
//           dispatch(logTransaction("Consultant Updation error", response))
//         }
//       })
//       .catch(err => {
//         failure && failure()
//         dispatch(logTransaction("Consultant Updation failure", err))
//       })
//   }
// }

export function updateLoginUserProfile(user, success, failure) {
    return function (dispatch, getState) {
        console.log(user, "lkfjlsdkfjsdjflskdf")
        const { userProfile } = getState().login
        let url = updateLoginUserProfileURL + `/${user.userId}`
        axiosPut(url, JSON.stringify({ ...user, email: userProfile.email }))
            .then(response => {
                if (response.data.statusCD === 200) {
                    localStorage.setItem("userProfile", JSON.stringify(user))
                    dispatch(logTransaction("user profile Updated", response))
                    success && success()
                } else {
                    failure &&
                        failure(
                            response.data.statusMSG ||
                                "Failed to update user profile"
                        )
                    dispatch(
                        logTransaction("user profile Updation error", response)
                    )
                }
            })
            .catch(err => {
                failure && failure("Failed to update user profile")
                dispatch(logTransaction("user profile Updation failure", err))
            })
    }
}

export function updateUserAccount(user, success, failure) {
    return function (dispatch, getState) {
        console.log(user, "lkfjlsdkfjsdjflskdf")
        let url = updateUserURL
        axiosPut(url, JSON.stringify(user))
            .then(response => {
                console.log("response fasdfasd", response)
                if (response.data.statusCD === 200) {
                    // localStorage.setItem("userProfile", JSON.stringify(user))
                    dispatch(logTransaction("user account Updated", response))
                    success && success(response.data.responseData)
                } else {
                    failure &&
                        failure(
                            response.data.statusCD === 409
                                ? "Email already exists. Try Different Email"
                                : null
                        )
                    dispatch(
                        logTransaction("user account Updation error", response)
                    )
                }
            })
            .catch(err => {
                console.log("catch method")
                console.log(err, "error in update user account")
                failure && failure()
                dispatch(logTransaction("user account Updation failure", err))
            })
    }
}

export function fetchStates(countryId, success, failure) {
    return function (dispatch, getState) {
        console.log(getState().login.userProfile, "kldjflsjfdslfk")
        let url = fetchStatesURL + `?countryId=${countryId}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData.length > 0
                ) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction("States fetched successfully", response)
                    )
                } else {
                    failure()
                    dispatch(logTransaction("States fetch failed", response))
                }
            })
            .catch(err => {
                failure && failure()
                dispatch(logTransaction("States fetch failed", err))
            })
    }
}

export function fetchCountries(success, failure) {
    return function (dispatch, getState) {
        let url = fetchCountriesURL
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData.length > 0
                ) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Countries fetched successfully",
                            response
                        )
                    )
                } else {
                    failure()
                    dispatch(logTransaction("Countries fetch failed", response))
                }
            })
            .catch(err => {
                console.log(err, "dljfsldfjlfldsf")
                failure()
                dispatch(logTransaction("Countries fetch failed", err))
            })
    }
}

export function getBlockoutDays(success, failure) {
    return function (dispatch, getState) {
        let url = getBlockoutDaysURL
        let user = getState().login.user
        console.log(user, "kldsjfljlsdfjfds")
        url += `?userId=${user.profileForUser[0].userId}`

        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(updateBlockoutDays(response.data.responseData))
                    success(response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Blockout fetched successfully",
                            response
                        )
                    )
                } else {
                    dispatch(updateBlockoutDays([]))
                    failure()
                    dispatch(logTransaction("Blockout fetch failed", response))
                }
            })
            .catch(err => {
                dispatch(updateBlockoutDays([]))
                failure()
                dispatch(logTransaction("Blockout fetch failed", err))
            })
    }
}

export function insertOrUpdateScheduleAudit(blockoutData, success, failure) {
    console.log(blockoutData, "dskljfslkdfj")
    return function (dispatch, getState) {
        let url = inserOrUpdateBlockoutURL
        const userId = getState().login.userProfile.userId
        const data = {
            userId,
            scheduleAuditStartAndEnd: [...blockoutData],
        }

        axiosPost(url, JSON.stringify(data))
            .then(response => {
                if (response.data.statusCD === 200) {
                    // dispatch(updateBlockoutDays([...response.data.responseData.scheduleAuditStartAndEnd]))
                    success()
                    dispatch(
                        logTransaction(
                            "insertOrUpdateScheduleAudit successfully",
                            response
                        )
                    )
                } else {
                    failure()
                    dispatch(
                        logTransaction(
                            "insertOrUpdateScheduleAudit successfully",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                // dispatch(updateBlockoutDays([]))
                failure && failure()
                dispatch(
                    logTransaction("insertOrUpdateScheduleAudit failed", err)
                )
            })
    }
}

export function updatePassword(data, success, failure) {
    return function (dispatch, getState) {
        let url = setNewPasswordURL
        url += `?userName=${
            Object.values(getState().login.user.userProfile)[0]
        }&currentPassword=${data.currPass}&newPassword=${
            data.newPass
        }&newPassword1=${data.confirmPass}`
        const putData = {
            userName: Object.values(getState().login.user.userProfile)[0],
            currentPassword: data.currPass,
            newPassword: data.newPass,
            newPassword1: data.confirmPass,
        }
        console.log(putData, "kdsjfklsfjdslkf")
        axiosPut(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    // if (response.data.responseData?.message) {
                    //   success()
                    //   dispatch(logTransaction("password updated successfully", response))
                    // } else {
                    //   failure(response.data.responseData?.error)
                    //   dispatch(logTransaction("password update unsuccessful", response))
                    // }
                    success()
                    dispatch(
                        logTransaction(
                            "password updated successfully",
                            response
                        )
                    )
                } else {
                    throw new Error("Password update unsuccessful")
                }
            })
            .catch(err => {
                failure(err.message)
                dispatch(logTransaction("password update failed", err))
            })
    }
}

export function fetchAssociatedClinicsUser() {
    return function (dispatch, getState) {
        // let id = getState().login.userProfile.id
        //   ? getState().login.userProfile.id
        //   : getState().login.userProfile.portalUserId
        let id = getState().login.userProfile.userId
        let url = getClinicsUserURL + `/${id}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(associatedClinicsUsers(response.data.responseData))
                    dispatch(
                        logTransaction(
                            "Fetch associated clinic success",
                            response
                        )
                    )
                } else {
                    dispatch(associatedClinicsUsers([]))
                    dispatch(
                        logTransaction(
                            "Fetch associated clinic Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                dispatch(associatedClinicsUsers([]))
                dispatch(logTransaction("Fetch associated clinic Failed", err))
            })
    }
}

export function loginTimeTracker(user, programId) {
    return function (dispatch, getState) {
        // let user = getState().login.user;
        let userId = user.profileForUser[0]?.userId
        let program = getState().user?.program
        let payload = {
            userId: userId,
            programId: programId || program.id,
        }
        console.log("input dataaa", payload)
        axiosPost(timeTrackerURL, payload)
            .then(response => {
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData
                ) {
                    console.log(
                        "response insert time tracker.......",
                        response.data.responseData
                    )
                    dispatch(logTransaction("Insert Time Tracker", payload))
                    dispatch(updateLoginTracker(response.data.responseData))
                } else {
                    dispatch(logTransaction("Insert Time Tracker", payload))
                }
            })
            .catch(err => {
                dispatch(logTransaction("Insert Time Tracker", err))
            })
    }
}

export function endLoginTimeTracker(isManualLogoff, token) {
    return function (dispatch, getState) {
        let loginTracker = getState().login.loginTracker
        let timeTrackerId = loginTracker.id
        let payload = {}
        let url =
            timeTrackerURL +
            `/${timeTrackerId}/end?isManualLogoff=${isManualLogoff}`
        let headers = {}
        if (token) {
            headers["Authorization"] = `${token.access_token}`
        }
        console.log("input dataaa", payload)
        axiosPut(url, payload, headers)
            .then(response => {
                if (response.data.statusCD == 200) {
                    console.log("response update time tracker.......", response)
                    dispatch(logTransaction("Update Time Tracker", payload))
                } else {
                    dispatch(logTransaction("Update Time Tracker", payload))
                }
            })
            .catch(err => {
                dispatch(logTransaction("Update Time Tracker", err))
            })
    }
}

export function getToken(payload, callback) {
    return function (dispatch, getState) {
        const token = JSON.parse(localStorage.getItem("userAuth"))
        axios
            .post("https://auth-uat.doctorite.ai/agora/token", payload, {
                headers: {
                    Authorization: token.access_token,
                },
            })
            .then(response => {
                callback(response)
            })
            .catch(err => {
                callback({ token: null })
            })
    }
}

export function sendOtpToLoginPhone(mobileNo, success, failure) {
    return function (dispatch, getState) {
        let phoneNumber = mobileNo.includes("+")
            ? mobileNo.replace("+", "%2b")
            : mobileNo
        // console.log("phone Number", phoneNumber);
        let url =
            sendOtpToLoginPhoneURL +
            `?loginPhone=${phoneNumber}&userType=patient`
        axiosPost(url)
            .then(res => {
                // setIsLoading(false)
                // console.log("Send OTP Response", res);
                if (res.status === 200 && res.data?.responseData) {
                    //   setPrevMobileNo(mobileNo);
                    success(res.data?.responseData)
                } else {
                    failure()
                }
            })
            .catch(err => {
                // setIsLoading(false)
                // console.log("Error Send OTP", err);
                // alert("Couldn't send the OTP at the moment");
                console.log(err, "otp failure")
                failure()
            })
    }
}

export function fetchDependantRelations(success, failure) {
    console.log(success, "drtyujhbvcfg")
    // console.log(,"drtyujhbvcfg")
    return async function (dispatch) {
        try {
            let url = lookupsURL + `?lookupCategoryId=${10146}&appLanguageId=1`
            const response = await axiosGet(url)
            if (
                response.data.statusCD === 200 &&
                response.data.responseData.length > 0
            ) {
                dispatch(logTransaction("Fetch Dependant Relations", response))
                success(response.data.responseData)
            } else {
                dispatch(
                    logTransaction("Fetch Dependant Relations Error", response)
                )
                failure([])
            }
        } catch (err) {
            console.log("login error", err)
            dispatch(logTransaction("Refresh Auth failure", err))
        }
    }
}

export function startActivityTimeTracker(data, success, failure) {
    return function (dispatch, getState) {
        let user = getState().login.user
        let userId = user.profileForUser[0]?.userId
        let program = getState().user?.program
        let payload = {
            userId: userId,
            category: data.category,
            relatedTab: data.relatedTab,
            programId: program.id,
        }
        console.log("input dataaa", payload)
        axiosPost(userTimeTrackingBasedOnCategoryURL, payload)
            .then(response => {
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData
                ) {
                    console.log(
                        "response insert time tracker.......",
                        response.data.responseData
                    )
                    // dispatch(logTransaction("Insert Time Tracker", payload))
                    // dispatch(updateLoginTracker(response.data.responseData))
                    dispatch(updateActivtyTracker(response.data.responseData))
                } else {
                    // dispatch(logTransaction("Insert Time Tracker", payload))
                }
            })
            .catch(err => {
                dispatch(logTransaction("Insert Time Tracker", err))
            })
    }
}

export function endActivityTimeTracker() {
    return function (dispatch, getState) {
        let activityTracker = getState().login.activityTracker
        if (!activityTracker) return // Add null check to avoid errors if no tracker exists
        let timeTrackerId = activityTracker.id
        let payload = {}
        let url = updateUserTimeTrackingBasedOnCategoryURL + `/${timeTrackerId}`
        axiosPut(url, payload)
            .then(response => {
                if (response.data.statusCD == 200) {
                    console.log(
                        "response update activity tracker.......",
                        response
                    )
                    dispatch(logTransaction("Update activity Tracker", payload))
                    dispatch(updateActivtyTracker(null))
                } else {
                    dispatch(logTransaction("Update activity Tracker", payload))
                }
            })
            .catch(err => {
                dispatch(logTransaction("Update activity Tracker", err))
            })
    }
}
